<template>
    <div class="wrapper">        
        <h1 class="title">
            <span>STEP 1 OF 2-Verify Aadhaar</span>                        
            <!-- <p class="guide">
                Step <em>{{ props.step }}</em> / {{ props.allstep }}
            </p> -->
        </h1>       
        <div class="element-wrapper">
            <!-- <div class="element-title">
                    <h3>Aadhaar Number</h3>            
                </div> -->
            <div class="element-content">
                <label for="">Aadhaar</label>
                <div class="element-input-container">
                    <input type="tel" v-model="idNo" :readonly="verify_state" @input="commonInput" @focus="inputFocus" @blur="inputBlur" placeholder="Please input Aadhaar Number.">
                </div>                
                <!-- <a href="javascript:void(0);" class="link" :class="{'verified':verify_state}" @click="clickVerify" v-text="verify_state ? 'Verified' : 'Verify'"></a> -->
            </div>
            <p class="cap">OTP will be sent to your Aadhaar-linked mobile</p>
        </div>
               
        <!-- <a href="javascript:void(0);" class="changetouploda-text" @click="changeVerify">Verify though taking pictures</a>             -->
        <div class="placeholder"></div>
        <div class="btn-container">
            <a class='btn-submit' @click="clickVerify">Send OTP</a>
        </div>      
        <div class="dialog-success" v-show="ds_show">
            <div class="dialog-success-content">
                <div class="dsc-title">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70" width="32px" id="successful-verification">
                        <path style="fill:#3aaa35" d="m35 3 7.43 4.29H51l4.29 7.42L62.71 19v8.57L67 35l-4.29 7.43V51l-7.42 4.29L51 62.71h-8.57L35 67l-7.43-4.29H19l-4.29-7.42L7.29 51v-8.57L3 35l4.29-7.43V19l7.42-4.29L19 7.29h8.57L35 3z"></path>
                        <path style="fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:5" d="m23.7 36.43 6.58 6.58L46.3 26.99"></path>
                    </svg>
                    <span class="dsc-title-text">Aadhaar verified</span>
                </div>
                <div class="dsc-content">
                    <h2 class="dsc-content-title">
                        Aadhaar No.
                    </h2>
                    <p class="dsc-content-text" v-text="idNo"></p>
                </div>
                <div class="dsc-btn">
                    <a href="javascript:void(0);" class="dsc-btn-submit" @click="jump">NEXT</a>
                </div>
            </div>
        </div>
        <div class="dialog-wrapper" v-show="code_dialog_show">
            <div class="dialog-code">
                <h1 class="title">
                    <span>STEP 2 OF 2-Verify Aadhaar</span>                                            
                </h1>       
                <div class="element-wrapper">                    
                    <div class="element-content-2">
                        <label for="">Enter OTP</label>                                                
                        <div class="element-input-container">                        
                            <input type="tel" @input="codeInput" placeholder="Please enter the OTP" id="code" v-model="verify_code">
                        </div>                                        
                        <a href="javascript:void(0);" class="send-otp" v-text="otp_text" @click="clickVerify"></a>    
                    </div>                    
                </div>                                    
                <div class="placeholder"></div>
                <div class="btn-container">
                    <a class='btn-submit' @click="verify">Verfiy OTP</a>
                </div>
            </div>
        </div>        
    </div>
</template>
<style lang="less" scoped>
.changetouploda-text{
    display: block;
    width: 400px;
    text-align: center;
    font-size:26px;
    color:#9C73E2;
    margin:50px auto;
    text-decoration: underline;
}
.caption{
    padding:10px 0;
    color:#9C73E2;
    line-height: 1.5;
    font-size: 24px;
}
.dialog-wrapper{
    position:fixed;
    width: 100%;
    height: 100%;
    left:0;
    top:0;
    right:0;
    bottom:0;
    background:rgba(0,0,0,0.6);    
    .dialog-code{
        width:690px;
        height:100%;
        margin:0 auto;
        position:absolute;
        // left:50%;
        // top:50%;
        // transform: translate(-50%,-50%);
        background:#FEF8EC;
        padding:110px 40px 40px;
        // border-radius: 20px;
        &.change{
            height:auto
        }
        .dialog-header{
            margin:20px 0;
            text-align: center;
            color:#9C73E2;
            font-size: 40px;
        }
    }
    .dialog-content{        
        .dialog-btn-container{
            width: 450px;
            margin:100px auto 0 auto;
            .submit-code{
                display:block;
                width: 450px;
                height: 100px;
                line-height: 100px;
                text-align: center;
                font-size: 36px;                
                border-radius: 10px;
                background:#9C73E2;
                color:#fff;
            }
        }
        .dialog-caption{
            font-size: 28px;
            color:#9C73E2;
            margin-top: 50px;
        }
        .form-element-container{
            display:flex;
            justify-content: space-between;
            align-items: center;
            border-bottom:1px solid #9C73E2;
            margin-top: 50px;
            padding:20px 0;
            .input-element{
                input{
                    display: block;
                    width: 100%;
                    height:100%;
                    color:#9C73E2;
                    font-size: 30px;
                    border:none;
                    padding:0;
                }
            }
            .send-otp{
                display: block;
                width:150px;
                height:40px;
                padding:10px;
                text-align: center;
                color:#fff;
                font-size: 28px;
                line-height: 40px;
                background:#9C73E2;
                border-radius: 10px;
            }
        }

    }
}
.element-wrapper{
    .element-title{
        padding:30px 0;
        h3{
            font-size:28px;
            color:#333; 
        }
    }
    .cap{
        font-size: 28px;
        color:#999;
        margin-top: 15px;
    }
    .element-content-2{
        padding: 0;
        position:relative;  
        margin-top: 30px;       
        .send-otp{
            display: block;            
            height:40px;
            padding:10px;
            text-align: left;
            color:#9C73E2;
            font-size: 28px;
            line-height: 40px;            
            border-radius: 10px;
        }              
        label{
            display: block;
            color:#686766;
            font-size:36px;
            margin:30px 0 20px 0;
            // width: 100px;
        }
        .element-input-container{
            height:50px;
            padding:10px 0;
            border:2px solid #EAEBEF; 
            border-radius: 20px;
            background:#fff;
            padding:20px;
            input{
                font-size:32px;
                color:#9C73E2;
                height:36px;
                line-height: 36px;
                height: 100%;
                border:none;
                width: 100%;
                letter-spacing: 10px;
                &::placeholder{
                    letter-spacing: 0;
                }
            }
        }
        .link{
            display:block;
            width:140px;
            height:60px;
            text-align:center;
            line-height:60px;
            font-size: 24px;
            background:#9C73E2;
            color:#fff;
            position:absolute;
            top:18px;
            right:20px;
            border-radius: 10px;
            &.verified{
                background:#f4d98f;
            }
        }
    }
    .element-content {
        padding:10px 30px;
        position:relative;
        border:2px solid #EAEBEF; 
        border-radius: 20px;
        background:#fff;
        display: flex;
        justify-content: start;   
        align-items: center;                
        label{
            display: block;
            color:#333;
            font-size:24px;
            margin-right: 20px;
            width: 100px;
        }
        .element-input-container{
            height:50px;
            padding:10px 0;
            flex:1 1 auto;
            input{
                font-size:32px;
                color:#9C73E2;
                height:36px;
                line-height: 36px;
                height: 100%;
                border:none;
                width: 100%;
            }
        }
        .link{
            display:block;
            width:140px;
            height:60px;
            text-align:center;
            line-height:60px;
            font-size: 24px;
            background:#9C73E2;
            color:#fff;
            position:absolute;
            top:18px;
            right:20px;
            border-radius: 10px;
            &.verified{
                background:#f4d98f;
            }
        }
    }
    
}
.btn-container{
    width: 670px;
    margin:0 auto;
    // padding:40px;
    // padding:40px;
    .btn-submit{
        display: block;
        width: 670px;
        height: 96px;
        line-height: 96px;
        text-align: center;
        border-radius: 12px;
        background:#9C73E2;
        font-size: 32px;
        font-weight: 700;
        margin:0 auto;
        color:#fff;
    }
}
.placeholder{
    height: 100px;        
}
.hih-caption{
    color:#A59BB3;
    font-size:28px;
    margin-bottom: 30px;
    line-height: 1.5;
}
.wrapper{
    padding:20px 40px;
    .guide{
        color:#A59BB3;
        font-size: 30px;
        em{
            color:#9C73E2;
            font-weight: 700;
        }
    }
    .title{
        color:#B29CE2;
        font-weight: 700;
        font-size: 30px;
        margin: 20px 0 50px 0;  
    }
}
div.dialog-success {
  position:fixed;
  width: 100%;
  height: 100%;
  left:0;
  top:0;
  right:0;
  bottom:0;
  background:rgba(0,0,0,0.6); 
  z-index:2;  
  div.dialog-success-content {
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%,-50%);
    background:rgb(254, 248, 236);
    padding:50px;
    width:570px;
    border-radius: 30px;
    div.dsc-title {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 50px;
      span.dsc-title-text {
        margin-left: 20px;
        color:#000;
      }
    }

    div.dsc-content {
      background:#fff;
      border-radius: 20px;
      padding:30px;
      margin-bottom: 50px;
      h2.dsc-content-title {
        color:#000;
        font-weight: 700;
        margin-bottom: 15px;
        font-size: 30px;
        margin-bottom: 30px;
        background: transparent;
      }

      p.dsc-content-text {
        color:#666;
        font-size: 30px;
      }
    }
    .dsc-btn{
        background:#9C73E2;
        text-align: center;
        width:400px;
        height:75px;        
        border-radius: 20px;
        margin:0 auto;       
        a{
            display: block;
            height:75px;
            line-height:75px;        
            color:#fff;
            font-size: 36px;
        }
    }
  }
}
</style>
<script>
import { onMounted, getCurrentInstance,ref } from 'vue'
import { useRouter } from 'vue-router'
import { adaPan, getKycinfo,sendValidateSms, submitValidateSms} from '@api/index'
import { useLoading } from 'vue-loading-overlay'
import { useStore } from 'vuex'
import { v4 as uuidv4} from 'uuid'
export default {
    props:{
        step:String,
        allstep:String
    },
    setup(props, ctx) {
        const $loading = useLoading()
        const store = useStore()

        const idNo = ref("")
        const panNo = ref("")
        const router = useRouter()
        const proxy = getCurrentInstance().proxy   
        const route = router.currentRoute
        const verify_dialog_show = ref(false)        
        const code_dialog_show = ref(false)
        const ds_show = ref(false)
        const otp_text = ref("send")
        const verify_code = ref("")
        const verify_state = ref(false)
        const verify_ing = ref(false)
        let requestId = ref(uuidv4())
        let inputCount = ref(0)
        const jump = () => {
            router.replace({
                "path":"/auth/index",
                "query":{
                    "pid":route.value.query.pid
                }
            })
        }                             
        // onBeforeMount(()=>{
        //     store.dispatch('bury', {eventId:"kyc_page_szy_view"})
        //     store.dispatch("clearBuryCache", [])
        // })
        // onBeforeUnmount(()=>{
        //     store.dispatch('bury', {eventId:"kyc_szy_exit_page_tech"})
        //     store.dispatch("clearBuryCache", [])
        // })
        // 提交    
        const submit = async () => {
            const loader = $loading.show({
                container: null
            }) 
            // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click"})
            const data = await adaPan({
                idNo:idNo.value,
                panNo:panNo.value,
            })
            if(data.code == 0) {
                loader.hide()
                // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success"})
                // store.dispatch("uploadBury")
                router.replace({
                    "path":"/auth/index",
                    "query":{
                        "pid":route.value.query.pid
                    }
                })
            } else {
                // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success", message:data.msg})
                proxy.$toast.show(data.msg)
                
            }
        }    
        onMounted(async () => {
            // document.body.style.background = "#fff"
            getKycinfo().then((res)=>{
                if(res.code == 0) {
                    idNo.value = res.data.aadhaar                    
                }
            })
            // document.body.style.background = '#F8F8F8'                        
        }) 
        const commonInput = () => {
            let input = idNo.value;         
            if (input.length > 12) {
                input = input.slice(0, 12);
            }   
            idNo.value = input;
        }
        // 输入验证 
        const codeInput = (e) => {
            // const reg = /[a-zA-Z!@#$%^&*(){}[].?]]/
            const reg1 = /\D+/
            const v = e.target.value
            if(reg1.test(v)) {
                verify_code.value = v.substring(0, v.length - 1)
            }
            else if(v.length > 6) {
                verify_code.value = v.substring(0, v.length - 1)                    
            }
            inputCount.value = inputCount.value + 1
        }  
        // 弹窗验证
        const verify = async () => {
            if(verify_code.value < 6) {
                proxy.$toast.show("Please enter Correct OTP")
                return
            }
            const loader = $loading.show({
                container: null
            })        
            let resp = await submitValidateSms({
                aadhaar:idNo.value.replace(/-/g,""),
                otp: verify_code.value
            })
            loader.hide()
            if(resp.code == '0') {
                // verify_state.value = true
                code_dialog_show.value = false
                ds_show.value = true
                
            } else {
                // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success",message: data.msg})
                proxy.$toast.show(resp.msg)
            }
        } 
        let st = 0  
        const shouldGoState = ref(0)
        const changeVerify = () => {
            ctx.emit("changeState", shouldGoState.value)
        }
        const clickVerify = async () => {  
            // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click"})
            if(verify_ing.value)return 
            if(verify_state.value == 1)return
            const paramsIdNo = idNo.value.replace(/-/g,"")
            if(paramsIdNo < 12) {
                proxy.$toast.show("Please enter Correct Aadhaar No.")
                return
            } 
            const loader = $loading.show({
                container: null
            }) 
            
            const data = await sendValidateSms({
                "aadhaar":idNo.value.replace(/-/g,"")
            })            
            loader.hide()
            if(data.code == 0) {     
                code_dialog_show.value = true                                     
                verify_ing.value = true
                        let sec = 60
                        st = setInterval(()=>{                            
                            sec--
                            otp_text.value = `${sec}s`
                            if(sec <= 0) {
                                otp_text.value = "Resend OTP"
                                clearInterval(st)
                                verify_ing.value = false
                            }
                        },1000)           
            } else {
                // store.dispatch('bury', {eventId:"kyc_page_szy_enter_button_click_success",message: data.msg})
                proxy.$toast.show(data.msg)
            }            
            loader.hide()
        }
        const validate = () => {
            let res = true
            if(idNo.value == '') {
                proxy.$toast.show('Please Input IDcard No.')
                res =false
            } else if (panNo.value == '') {
                proxy.$toast.show('Please Input Pan Id. ')
                res =false
                
            } 
            return res
        }        
        const bootomFocus = (e) => {
            e.target.scrollIntoView({ block: "center" })
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['panNo']['focus'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            } 
        }
        const panBlurs = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['panNo']['complete'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: inputCount.value                 
                })            
                requestId.value = uuidv4()
                inputCount.value = 0
            } catch(e) {
                console.log(e)
            }
        }
        const adaBlurs = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['idNo']['complete'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: inputCount.value                 
                })            
                requestId.value = uuidv4()
                inputCount.value = 0
            } catch(e) {
                console.log(e)
            }
        }
        const adaFocus = (e)=>{            
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['idNo']['focus'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            } 
        }
        const adaCodeFocus = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['smsCode']['focus'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: 0                   
                })            
            } catch(e) {
                console.log(e)
            } 
        }
        const adaCodeBlurs = (e) => {
            try{
                store.dispatch('buryCache', { 
                    'event_id':  store.state.buryConfig["kyc_page"]['smsCode']['complete'], 
                    value: e.target.value, 
                    requestId:requestId.value,
                    numberTimes: inputCount.value                 
                })            
                requestId.value = uuidv4()
                inputCount.value = 0
            } catch(e) {
                console.log(e)
            }
        }

        const inputFocus = () => {
            idNo.value = idNo.value.replace(/-/g, "")
        }
        const inputBlur = () => {
            let input = idNo.value
            input = input.replace(/(\d{4})(?=\d)/g, '$1-');
            idNo.value = input;
        }

        return {
            inputFocus,
            inputBlur,
            ds_show,
            adaCodeBlurs,
            adaCodeFocus,
            panBlurs,
            adaBlurs,
            adaFocus,
            props,
            idNo,
            panNo,
            submit,
            validate,
            clickVerify,
            bootomFocus,
            code_dialog_show,
            verify_dialog_show,
            otp_text,
            codeInput,
            verify,
            verify_code,
            verify_state,
            commonInput,
            changeVerify,
            jump
        }
        
    }
}
</script>